const render = () => {
  require('./AppRenderer');  
};
render();

